// extracted by mini-css-extract-plugin
module.exports = {"versionsTitle":"VersionNumbers_versionsTitle__3Byzq","versionsMinimal":"VersionNumbers_versionsMinimal__3leJM"};